// Formatovani cisel a meny pro UI.
// Vnitrne pracujeme s cisly (Number) v Kc, pri vystupu zaokrouhlujeme na 2 desetinna mista.

const nfMoney = new Intl.NumberFormat('cs-CZ', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const nfQty = new Intl.NumberFormat('cs-CZ', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 4,
});

/**
 * Naformatuje cislo jako cenu s mernou jednotkou.
 * @param {number} value
 * @param {string} [currency="Kč"]
 */
export function formatMoney(value, currency = 'Kč') {
  if (!Number.isFinite(value)) return '';
  return `${nfMoney.format(value)} ${currency}`;
}

/** Naformatuje pocet (mnozstvi) – zachovava az 4 desetinna mista. */
export function formatQty(value) {
  if (!Number.isFinite(value)) return '';
  return nfQty.format(value);
}

/**
 * Bezpecne nacte cislo z uzivatelskeho vstupu.
 * Akceptuje "1 234,56", "1234.56", "1234".
 * Vraci NaN, pokud vstup neni cislo.
 * @param {string|number|null|undefined} input
 * @returns {number}
 */
export function parseNumber(input) {
  if (typeof input === 'number') return input;
  if (input == null) return NaN;
  const cleaned = String(input).replace(/\s+/g, '').replace(',', '.');
  if (cleaned === '') return NaN;
  return Number(cleaned);
}
